import React, {Fragment, useContext, useEffect, useState} from "react";
import {Store} from "../../../app/stores/store-root";
import {
    EuiCheckboxGroup,
    EuiDescribedFormGroup,
    EuiFieldNumber,
    EuiFormRow,
    EuiLink,
    EuiPanel,
    EuiRadioGroup
} from "@elastic/eui";
import {useFormikContext} from "formik";
import {Exchange} from "../../../app/models/exchange-types";
import {observer} from "mobx-react-lite";
import * as _ from 'lodash';

type SettingsProps = {
    currencyCode: string;
    currencySymbol: string;
    submitting: boolean;
    showReceivingAgentRoles?: boolean;
}
const Settings = ({currencySymbol, currencyCode, submitting, showReceivingAgentRoles}: SettingsProps) => {
        const store = useContext(Store);
        const formik = useFormikContext();
        const [exchanges, setExchanges] = useState<any[]>([]);
        const [showBalanceLimitFieldAndExchanges, setShowBalanceLimitFieldAndExchanges] = useState(false);
        const [checkboxIdToSelectedMap, setCheckboxIdToSelectedMap] = useState<any>({});
        const [selectedRole, setSelectedRole] = useState<any>('');
        const roles = [
            {
                id: 'BUSINESS_ADMIN',
                label: 'Business Administrator'
            },
            {
                id: 'SEND_AGENT',
                label: 'Sending Agent'
            },
            {
                id: 'RECEIVE_AGENT',
                label: 'Receiving Admin'
            },
            {
                id: 'RECEIVE_AGENT_CASHIER',
                label: 'Cashier'
            },
            {
                id: 'RECEIVE_AGENT_SUPERVISOR',
                label: 'Supervisor'
            },
        ]
        const receivingAgentRoles = [
            {
                id: 'RECEIVE_AGENT_CASHIER',
                label: 'Cashier'
            },
            {
                id: 'RECEIVE_AGENT_SUPERVISOR',
                label: 'Supervisor'
            },
        ]
        const onAllowedExchangesChange = (optionId: string) => {

            const newCheckboxIdToSelectedMap = {
                ...checkboxIdToSelectedMap,
                ...{
                    [optionId]: !checkboxIdToSelectedMap[optionId],
                },
            };
            setCheckboxIdToSelectedMap(newCheckboxIdToSelectedMap);
            var stage1 = _.filter(_.toPairs(newCheckboxIdToSelectedMap), (item) => {
                return item[1];
            });
            var data = _.map(stage1, (item: any) => item[0]);
            formik.getFieldHelpers('AllowedExchanges').setValue(data);
        };

        const onRoleChanges = (optionId: string) => {
            setSelectedRole(optionId);
            formik.getFieldHelpers('Role').setValue(optionId);
            if (optionId == 'BUSINESS_ADMIN' || optionId == 'SEND_AGENT') {
                setShowBalanceLimitFieldAndExchanges(true);
            } else {
                setShowBalanceLimitFieldAndExchanges(false);
                formik.getFieldHelpers('Limit').setValue(10);
                formik.getFieldHelpers('AllowedExchanges').setValue(["NoExchange"]);
            }
        }


        useEffect(() => {
                const transformed = store.Exchanges.exchanges.map((item: Exchange) => {
                    return {id: item.Id, label: item.Label}
                })
                setExchanges(transformed);
                setSelectedRole(formik.getFieldProps('Role').value)

                const role = formik.getFieldProps('Role').value;
                if (role == 'BUSINESS_ADMIN' || role == 'SEND_AGENT') {
                    setShowBalanceLimitFieldAndExchanges(true);
                }

                const exchanges: string[] = formik.getFieldProps('AllowedExchanges').value;
                const x: any = _.reduce(exchanges, (result: any, value: any) => {
                    return {
                        ...result,
                        ...
                            {
                                [value]:
                                    true
                            }
                    }
                }, {})
                setCheckboxIdToSelectedMap(x);


            }, [formik, store.Exchanges.exchanges]
        )

        return (
            <Fragment>
                <EuiPanel>
                    <EuiDescribedFormGroup title={<h3>Money Remittance roles</h3>}
                                           description={
                                               <Fragment>
                                                   please select the appropriate role
                                               </Fragment>
                                           }>

                        <EuiFormRow label='Assigned Role'
                                    isInvalid={((formik.getFieldMeta('Role').error) && (formik.getFieldMeta('Role').touched)) ? true : false}
                                    error={formik.getFieldMeta('Role').error}>
                            <EuiRadioGroup
                                options={(showReceivingAgentRoles)?receivingAgentRoles: roles}
                                idSelected={selectedRole}
                                onChange={(id: string) => onRoleChanges(id)}
                                name="Role"
                                disabled={submitting}

                            />

                        </EuiFormRow>
                        {(showBalanceLimitFieldAndExchanges) ? (<EuiFormRow label='Balance Limit'
                                                                            isInvalid={((formik.getFieldMeta('Limit').error) && (formik.getFieldMeta('Limit').touched)) ? true : false}
                                                                            error={formik.getFieldMeta('Limit').error}>
                            <EuiFieldNumber prepend={currencyCode}
                                            disabled={submitting}
                                            append={currencySymbol} {...formik.getFieldProps('Limit')}
                                            isInvalid={((formik.getFieldMeta('Limit').error) && (formik.getFieldMeta('Limit').touched)) ? true : false}/>
                        </EuiFormRow>) : ''}


                        {(showBalanceLimitFieldAndExchanges) ? (<EuiFormRow label='Allowed Currency Exchanges'
                                                                            isInvalid={((formik.getFieldMeta('AllowedExchanges').error) && (formik.getFieldMeta('AllowedExchanges').touched)) ? true : false}
                                                                            error={formik.getFieldMeta('AllowedExchanges').error}>
                            <EuiCheckboxGroup options={exchanges}
                                              onChange={(e) => onAllowedExchangesChange(e)}
                                              disabled={submitting}
                                              idToSelectedMap={checkboxIdToSelectedMap}
                            />
                        </EuiFormRow>) : ''}

                    </EuiDescribedFormGroup>
                </EuiPanel>
            </Fragment>);
    }
;

export default observer(Settings)
